import {validateDiscountPercentage, validateDiscountAmount} from './validation'

export const DISCOUNT_ITEMS = [
	{id: 'no_discount', t: 'records.default.fields.no_discount'},
	{id: 'discount_amt_per_user', t: 'records.default.fields.discount_amt_per_user', validate: validateDiscountAmount},
	{id: 'discount_pct', t: 'records.default.fields.discount_pct', validate: validateDiscountPercentage},
	{id: 'fixed_amt_per_env', t: 'records.default.fields.fixed_amt_per_env', validate: validateDiscountAmount},
	{id: 'fixed_amt_per_user', t: 'records.default.fields.fixed_amt_per_user', validate: validateDiscountAmount},
]
